/**
 * Detect whether local storage is available
 */
export default type => {
	try {
		const storage = window[type || "localStorage"],
			key = '__storage_test__';
		storage.setItem(key, key);
		storage.removeItem(key);
		return true;
	} catch (e) {
		return false;
	}
}
